<template>
<div class="father">
  <section class="top">
    <!-- <div class="top"> -->
      <div class="container">
        <div class="logo point" @click="returnHome"><img src="../assets/logo@4x.png" alt=""></div>
        <div class="info" >
          <span class="userName" v-if="$store.getters.roler==='admin'" >{{userName}}</span>
          <span class="point" v-if="$route.name !== 'Login'" @click="slogin">{{$store.getters.roler === 'admin' ? '退出' : '登录'}}</span>
        </div>
      </div>
    <!-- </div> -->
  </section>
</div>

</template>
<script>
import Api from '@/api/api'
export default {
  /******************************************
  ** 组件名称
  * @description 组件描述
  * @author ah
  *****************************************
  prop1          <type>            <属性描述>
  *****************************************/
  name: 'HelpCenterBar',
  components: {},
  props: {},
  data () {
    return {
      userName: '产品运营',
      status: this.$store.getters.roler === 'admin' ? '退出' : '登录'
    }
  },
  computed: {},
  mounted () {
    // console.log(this.$store.getters.roler)
    // console.log(this.$route)
  },
  methods: {
    returnHome () {
      this.$router.push('/')
    },
    slogin (e) {
      // console.log(e)
      let statusText = e.target.innerText
      // console.log(statusText)
      if (statusText === '退出') {
        Api.quit().then(res => {
          // console.log(res)
          this.$store.dispatch('setRoler', 'user')
          // this.status = '登录'
          this.$router.push('/')
        }).catch(err => {
          console.log(err)
        })
      } else {
        this.$router.push('/Login')
      }
    }
  }
}
</script>
<style lang="less" scoped>
.father{
  width: 100%;
  .top{
    width: 100%;
    // height:50px;
    height:0.3rem;
    line-height:0.3rem;
    // line-height: 50px;
    background-color: #F7F7F7;
    .container{
      width: 88%;
      margin:0 auto;
      // background-color: pink;
      display:flex;
      justify-content: space-between;
      z-index:9999;
      .logo{
        // height:30px;
        height: 0.15rem;
        line-height:0.15rem;
        // line-height: 30px;
        // margin:auto 0;
        // background-color: #A1A1A1 ;
        color:#fff;
        border-radius:5px;
        // background-image: url(../assets/logo@4x.png)
        img{
          margin-top:10px;
          // width: 100px;
          // height:30px;
          width: 0.5rem;
          height: 0.15rem;
        }
      }
      .info{
        box-sizing:border-box;
        // font-size:13px;
        font-size:0.08rem;
        color: #A1A1A1 ;
        .userName{
          // margin-right:15px;
          margin-right:0.08rem;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/HelpCenterBar.vue